import clsx from 'clsx';

export default function Card({ className, children, ...props }) {
  return (
    <div className={clsx('card p-3 sm:p-4', className)} {...props}>
      {children}
    </div>
  );
}

